import BackgroundImage from '@/models/BackgroundImage';

export default class BackgroundImageRepository {
    public static getAll() {
        return BackgroundImage.query().withAll().get();
    }

    public static getById(id: string) {
        return BackgroundImage.query().whereId(id).withAll().first();
    }

    public static delete(id: string) {
        return BackgroundImage.delete(id);
    }
}
